// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { rawRequest, ServiceResult } from "@insite/client-framework/Services/ApiService";

const getPriceBookUri = "api/synd/price-book";

export async function getPriceBook(): Promise<ServiceResult<any>> {
    try {
        const res = await rawRequest(getPriceBookUri);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition = res.headers.get("content-disposition") ?? "price-book.xlsx";
        const filename = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i)?.[1];
        link.download = filename ?? "price-book.xlsx";
        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(url);
        return {
            result: res,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error,
            };
        }
        throw error;
    }
}
